/**
* 請求管理
*/
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    /**
     * 検索条件
     */
    condition: {
      /* 請求月度 */
      billing_month: null,
      /* 請求先ID */
      billing_address_id: null,
      /* 締め日 */
      close_day_type: null,
      /* ステータス */
      status: null,
      /* 請求支払区分 */
      billing_payment_type: null,
      /* 請求書発行状況 */
      billing_output_setting: null,
      /* 一覧表示件数 */
      limit: 50,
    },
  }
}

const sales_request = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 請求一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { Object } 検索条件
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions }) {
        dispatch('saveCondition', { conditions: conditions });
      const parameters = {
        ...state.condition,
        limit: state.condition.limit,
        page: conditions.page,
      }
      return new Promise((resolve) => {
        const api_path = conditions.format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
        Vue.$http.get(api_path, { params: parameters }).then(data => {
          if (conditions.format !== 'csv') {
            let content = data.content
            commit(types.DRIVER_SALES_REQUEST_PAGINATION, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    /**
     * 請求詳細
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 仮締め/未締め更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 検索条件の保持
     * @param commit
     * @param state
     * @param conditions
     */
    saveCondition ( { commit, state }, { conditions } ) {
      const _billing_month = (conditions.billing_month !== undefined) ? conditions.billing_month : state.condition.billing_month
      const _billing_address_id = (conditions.billing_address_id !== undefined) ? conditions.billing_address_id : state.condition.billing_address_id
      const _close_day_type = (conditions.close_day_type !== undefined) ? conditions.close_day_type : state.condition.close_day_type
      const _status = (conditions.status !== undefined) ? conditions.status : state.condition.status
      const _bill_payment_type = (conditions.bill_payment_type !== undefined) ? conditions.bill_payment_type : state.condition.bill_payment_type
      const _bill_output_setting = (conditions.bill_output_setting !== undefined) ? conditions.bill_output_setting : state.condition.bill_output_setting
      const _limit = (conditions.limit !== undefined) ? conditions.limit : state.condition.limit
      const params = {
        billing_month: _billing_month,
        billing_address_id: _billing_address_id,
        close_day_type: _close_day_type,
        status: _status,
        bill_payment_type: _bill_payment_type,
        bill_output_setting: _bill_output_setting,
        limit: _limit,
      }
      commit(types.DRIVER_SALES_REQUEST_CONDITION, { conditions: params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_REQUEST_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_REQUEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_REQUEST_CONDITION] (state, { conditions }) {
      Object.assign(state.condition, conditions)
    },
    [types.DRIVER_SALES_REQUEST_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_REQUEST_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_REQUEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },


}
export default sales_request
